import { createFileRoute, redirect } from "@tanstack/react-router";

// `/` always lands on `/compare`. Chart versions lives at `/versions`.
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/compare", replace: true });
  },
});
